import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// 3rd party
import { NgxLoadingModule } from 'ngx-loading';
// Components
import { ModalComponent } from './components/modal/modal.component';
import { DynamicHostDirective } from './directives/dynamic-host.directive';
import { RemotebashComponent } from './remotebash/remotebash.component';
import { LoadingModalComponent } from './loading-modal/loading-modal.component';
import { FormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';

@NgModule({
    declarations: [
        ModalComponent,
        DynamicHostDirective,
        RemotebashComponent,
        LoadingModalComponent
    ],
    imports: [
        CommonModule,
        NgxLoadingModule,
        FormsModule,
        InputSwitchModule     
    ],
    exports: [
        ModalComponent,
        DynamicHostDirective,
        LoadingModalComponent
    ]
})
export class NRModalModule { }
